let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7vMvR")).then(() => parcelRequire('sFJC1'));